<template>
  <div class="data-migration-introduce">
    <common-bg-plate>
      <detail-section title="数据迁移说明">
        <el-row>
          <el-col :span="8">
            <div class="introduce-info">
              <div class="introduce-title">
                数据迁移说明
              </div>
              <div class="introduce-introduce">
                迁移工具的目的是将当前基于Fabric
                1.4.x版本的区块链系统转换为Chainmaker的最新版本v2.3，并同时保留原始区块数据。该迁移工具将实现从Fabric到Chainmaker的数据迁移和转换，确保数据的完整性和连续性，以满足业务需求。在迁移过程中，将开发兼容性验证、数据备份与恢复、迁移工具以及数据验证等功能，以确保平稳、可靠地完成区块链系统的迁移工作。
              </div>
            </div>
          </el-col>
        </el-row>
      </detail-section>
    </common-bg-plate>
  </div>
</template>

<script>
export default {
  name: 'Introduce',
  components: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'data-migration-introduce',
  (
    --data-migration-introduce-color: #ffffff,
    --data-migration-introduce-background-color: #3a456d,
    --data-migration-introduce-content-detail-color: #e7e9f3
  ),
  (
    --data-migration-introduce-color: #192227,
    --data-migration-introduce-background-color: #f6f7f9,
    --data-migration-introduce-content-detail-color: #19222799
  )
);
.data-migration-introduce {
  @include adaptation(
    (
      --data-migration-introduce-height: 255px,
      --data-migration-introduce-content-height: 171px,
      --data-migration-introduce-row-margin: 0 -12px,
      --data-migration-introduce-col-padding: 0 12px,
      --data-migration-introduce-background-size: 215px 167px,
      --data-migration-introduce-content-border-radius: 4px,
      --data-migration-introduce-content-padding: 16px,
      --data-migration-introduce-content-title-font-size: 18px,
      --data-migration-introduce-content-title-margin-bottom: 12px,
      --data-migration-introduce-content-detail-font-size: 12px,
      --data-migration-introduce-content-detail-height: 103px
    )
  );
  .common-bg-plate {
    min-height: var(--data-migration-introduce-height);
    height: var(--data-migration-introduce-height);

    .el-row {
      margin: var(--data-migration-introduce-row-margin);

      .el-col {
        padding: var(--data-migration-introduce-col-padding);

        .introduce-info {
          color: var(--data-migration-introduce-color);
          height: var(--data-migration-introduce-content-height);
          background-color: var(--data-migration-introduce-background-color);
          background-image: url('~@/assets/images/datamigration/intro-bg.png');
          background-size: var(--data-migration-introduce-background-size);
          background-repeat: no-repeat;
          background-position: right top;
          border-radius: var(--data-migration-introduce-content-border-radius);
          padding: var(--data-migration-introduce-content-padding);

          .introduce-title {
            font-size: var(--data-migration-introduce-content-title-font-size);
            font-weight: 500;
            margin-bottom: var(--data-migration-introduce-content-title-margin-bottom);
          }

          .introduce-introduce {
            color: var(--data-migration-introduce-content-detail-color);
            font-size: var(--data-migration-introduce-content-detail-font-size);
            overflow-y: auto;
            height: var(--data-migration-introduce-content-detail-height);
          }
        }
      }
    }
  }
}
</style>
